<script setup lang="ts">
import type { DemoSlot } from '../../model/demo-slot/interfaces'

import { AppSelect } from '@shared/ui/selects'

import { useSelectKid } from '../../model/shift-control/select-kid.hook'

defineOptions({
  name: 'SelectKid',
})

const props = defineProps<{
  tutorSlot: DemoSlot
}>()

const refTutorSlot = computed(() => props.tutorSlot)

const {
  options,
  modelValue,
  disabled,
  assignKid,
} = useSelectKid({ tutorSlot: refTutorSlot })
</script>

<template>
  <AppSelect
    :model-value="modelValue"
    :options="options"
    :disabled="disabled"
    placeholder="Select kid"
    @update:model-value="assignKid"
  />
</template>
